/*
 * @Author: czj
 * @Date: 2026-06-12 10:00:33
 * @Description: 路由实例 — 仅包含常量路由，动态路由由权限守卫注入
 * @FilePath: \kp-rag-system\src\router\index.js
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import constantRoutes from './constantRoutes'

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
})

export default router
